import releaseMetadata from './releaseMetadata.json';

const stripTrailingSlash = (value) => (value || '').replace(/\/+$/, '');
const envValue = (name) => process.env[name] || '';

export const API_BASE_URL = stripTrailingSlash(envValue('REACT_APP_API_URL'));
export const APP_RELEASE_NUMBER = releaseMetadata.releaseNumber;
export const APP_VERSION = APP_RELEASE_NUMBER;
export const APOLLO_APP_ID = envValue('REACT_APP_APOLLO_APP_ID');
export const APOLLO_TRACKER_URL = envValue('REACT_APP_APOLLO_TRACKER_URL');

export const apiUrl = (endpoint) => {
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  const endpointPath =
    API_BASE_URL.endsWith('/api') && normalizedEndpoint.startsWith('/api/')
      ? normalizedEndpoint.slice('/api'.length)
      : normalizedEndpoint;

  return `${API_BASE_URL}${endpointPath}`;
};

const isStripeTestMode = String(process.env.REACT_APP_STRIPE_TEST_MODE || '').toLowerCase() === 'true';

const stripePaymentLink = (paymentLinkEnvName, testPaymentLinkEnvName) => {
  const paymentLink = envValue(paymentLinkEnvName);
  const testPaymentLink = envValue(testPaymentLinkEnvName);

  return isStripeTestMode ? testPaymentLink : paymentLink;
};

export const STRIPE_PAYMENT_LINKS = Object.freeze({
  starter: stripePaymentLink('REACT_APP_STRIPE_STARTER_PAYMENT_LINK', 'REACT_APP_STRIPE_STARTER_TEST_PAYMENT_LINK'),
  professional: stripePaymentLink('REACT_APP_STRIPE_PROFESSIONAL_PAYMENT_LINK', 'REACT_APP_STRIPE_PROFESSIONAL_TEST_PAYMENT_LINK'),
  unlimited: stripePaymentLink('REACT_APP_STRIPE_UNLIMITED_PAYMENT_LINK', 'REACT_APP_STRIPE_UNLIMITED_TEST_PAYMENT_LINK')
});
